import { CanDeactivateFn } from '@angular/router';
// import { inject } from '@angular/core';
// import { DialogService } from '../services/dialog.service';

export interface CanComponentDeactivate {
  canDeactivate?: () => Promise<boolean> | boolean;
  deactivate?: () => void;
}

// A CanDeactivate guard must be a pure predicate: it answers "may I leave?" and
// nothing more. It must NOT perform teardown, because the router can still abort
// the navigation after the guard passes (e.g. a redirect that resolves to the
// current URL is dropped as a same-URL navigation). Teardown that ran here would
// then leave the component destroyed-but-mounted and permanently blank.
// The actual teardown (deactivate()) runs from BaseComponent.ngOnDestroy instead,
// which only fires when the component is genuinely destroyed.
export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (component: CanComponentDeactivate) => {
  if (component.canDeactivate) {
    return Promise.resolve(component.canDeactivate());
  }
  return true;
}